// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Bloque «Documentación de la empresa» del Dashboard ─────────────────────
   Usa las variables de tema de la CMDB (--bg-surface, --border…) para que se
   lea igual en los 12 temas y en las 5 pieles, incluidas las Lumina oscuras
   donde --bg-card es translúcido. */

.dbd {
  background: var(--bg-surface, var(--bg-card));
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 1rem 1.15rem;
  margin-bottom: 1.25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .08);
}

/* ── Cabecera ── */
.dbd-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}
.dbd-head-copy { min-width: 220px; }
.dbd-title {
  margin: 0;
  font-size: 1.02rem;
  font-weight: 700;
  color: var(--text-primary);
}
.dbd-subtitle {
  margin: .15rem 0 0;
  font-size: .8rem;
  color: var(--text-muted);
}
.dbd-head-actions {
  display: flex;
  align-items: center;
  gap: .5rem;
  flex-wrap: wrap;
}

.dbd-search {
  min-width: 220px;
  padding: .42rem .6rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--bg-input, rgba(255, 255, 255, .06));
  color: var(--text-primary);
  font-size: .82rem;
}
.dbd-search::placeholder { color: var(--text-muted); }
.dbd-search:focus { outline: none; border-color: var(--accent); }

.dbd-btn {
  padding: .42rem .75rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--bg-input, rgba(255, 255, 255, .06));
  color: var(--text-secondary);
  font-size: .8rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.dbd-btn:hover { border-color: var(--accent); color: var(--accent); }
.dbd-btn.is-primary {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
}
.dbd-btn.is-primary:hover { filter: brightness(1.1); color: #fff; }
.dbd-btn:disabled { opacity: .6; cursor: not-allowed; }

/* ── Formulario de nota rápida ── */
.dbd-form {
  display: flex;
  flex-wrap: wrap;
  gap: .5rem;
  margin-top: .85rem;
  padding: .8rem;
  border-radius: 10px;
  border: 1px dashed var(--border);
  background: rgba(var(--accent-rgb, 99, 102, 241), .06);
}
.dbd-input {
  flex: 1 1 240px;
  padding: .45rem .65rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--bg-input, rgba(255, 255, 255, .06));
  color: var(--text-primary);
  font-size: .84rem;
}
.dbd-input::placeholder { color: var(--text-muted); }
.dbd-input:focus { outline: none; border-color: var(--accent); }
.dbd-form-actions { display: flex; gap: .5rem; align-items: center; }
.dbd-form-error {
  flex: 1 1 100%;
  font-size: .78rem;
  color: #dc2626;
}

/* ── Listado ── */
.dbd-list {
  list-style: none;
  margin: .9rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.dbd-row {
  display: flex;
  gap: .7rem;
  padding: .65rem .25rem;
  border-top: 1px solid var(--border);
}
.dbd-row:first-child { border-top: none; }
.dbd-row-icon { font-size: 1.05rem; line-height: 1.5; }
.dbd-row-main { flex: 1 1; min-width: 0; }

.dbd-row-titleline {
  display: flex;
  align-items: center;
  gap: .5rem;
  flex-wrap: wrap;
}
.dbd-row-title {
  background: none;
  border: none;
  padding: 0;
  font-size: .9rem;
  font-weight: 700;
  color: var(--text-primary);
  cursor: pointer;
  text-align: left;
}
.dbd-row-title:hover { color: var(--accent); text-decoration: underline; }
.dbd-status {
  font-size: .64rem;
  font-weight: 700;
  padding: .1rem .4rem;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: .03em;
}
.dbd-status.is-draft     { background: rgba(234, 179, 8, .18);  color: #ca8a04; }
.dbd-status.is-published { background: rgba(22, 163, 74, .18);  color: #16a34a; }
.dbd-row-date { font-size: .72rem; color: var(--text-muted); }
.dbd-row-open {
  margin-left: auto;
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  font-size: .9rem;
  line-height: 1;
  padding: 0 .2rem;
}
.dbd-row-open:hover { color: var(--accent); }
.dbd-row-desc {
  margin: .2rem 0 0;
  font-size: .78rem;
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

/* ── Chips de elementos vinculados ── */
.dbd-links {
  display: flex;
  flex-wrap: wrap;
  gap: .35rem;
  margin-top: .45rem;
}
.dbd-chip {
  display: inline-flex;
  align-items: center;
  gap: .3rem;
  max-width: 260px;
  padding: .18rem .5rem;
  border-radius: 999px;
  border: 1px solid rgba(var(--accent-rgb, 99, 102, 241), .35);
  background: rgba(var(--accent-rgb, 99, 102, 241), .12);
  color: var(--accent);
  font-size: .72rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dbd-chip:hover { background: rgba(var(--accent-rgb, 99, 102, 241), .22); }
.dbd-chip.is-static {
  cursor: default;
  border-color: var(--border);
  background: var(--bg-input, rgba(255, 255, 255, .06));
  color: var(--text-muted);
}
.dbd-chip.is-more {
  border-style: dashed;
  border-color: var(--border);
  background: transparent;
  color: var(--text-muted);
}
.dbd-chip.is-more:hover { border-color: var(--accent); color: var(--accent); }
.dbd-links-none { font-size: .74rem; color: var(--text-muted); font-style: italic; }

.dbd-more {
  margin-top: .6rem;
  background: none;
  border: none;
  padding: 0;
  color: var(--accent);
  font-size: .8rem;
  font-weight: 600;
  cursor: pointer;
}
.dbd-more:hover { text-decoration: underline; }

/* ── Estados vacíos / error ── */
.dbd-empty {
  margin-top: .85rem;
  padding: 1rem;
  border-radius: 10px;
  border: 1px dashed var(--border);
  text-align: center;
  color: var(--text-muted);
  font-size: .82rem;
}
.dbd-empty-icon { font-size: 1.6rem; display: block; margin-bottom: .3rem; opacity: .6; }
.dbd-empty-title { margin: 0; font-weight: 700; color: var(--text-secondary); font-size: .88rem; }
.dbd-empty-copy { margin: .2rem 0 0; font-size: .78rem; }
.dbd-error {
  margin-top: .85rem;
  padding: .6rem .8rem;
  border-radius: 10px;
  background: rgba(220, 38, 38, .12);
  border: 1px solid rgba(220, 38, 38, .4);
  color: #dc2626;
  font-size: .8rem;
}

.dbd.is-full {
  margin-bottom: 0;
  padding: 1.15rem 1.3rem;
}
.dbd.is-full .dbd-title { font-size: 1.15rem; }

@media (max-width: 720px) {
  .dbd-head-actions { width: 100%; }
  .dbd-search { flex: 1 1 100%; min-width: 0; }
}
`, "",{"version":3,"sources":["webpack://./src/components/DashboardDocs.css"],"names":[],"mappings":"AAAA;;;oCAGoC;;AAEpC;EACE,6CAA6C;EAC7C,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;AACA,iBAAiB,gBAAgB,EAAE;AACnC;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;EAC/B,qDAAqD;EACrD,0BAA0B;EAC1B,iBAAiB;AACnB;AACA,2BAA2B,wBAAwB,EAAE;AACrD,oBAAoB,aAAa,EAAE,2BAA2B,EAAE;;AAEhE;EACE,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,qDAAqD;EACrD,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA,iBAAiB,2BAA2B,EAAE,oBAAoB,EAAE;AACpE;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;AACb;AACA,4BAA4B,uBAAuB,EAAE,WAAW,EAAE;AAClE,oBAAoB,WAAW,EAAE,mBAAmB,EAAE;;AAEtD,oCAAoC;AACpC;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,qDAAqD;EACrD,0BAA0B;EAC1B,iBAAiB;AACnB;AACA,0BAA0B,wBAAwB,EAAE;AACpD,mBAAmB,aAAa,EAAE,2BAA2B,EAAE;AAC/D,oBAAoB,aAAa,EAAE,UAAU,EAAE,mBAAmB,EAAE;AACpE;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,mCAAmC;AACrC;AACA,uBAAuB,gBAAgB,EAAE;AACzC,gBAAgB,kBAAkB,EAAE,gBAAgB,EAAE;AACtD,gBAAgB,SAAO,EAAE,YAAY,EAAE;;AAEvC;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;AACA,uBAAuB,oBAAoB,EAAE,0BAA0B,EAAE;AACzE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;AACvB;AACA,2BAA2B,kCAAkC,GAAG,cAAc,EAAE;AAChF,2BAA2B,kCAAkC,GAAG,cAAc,EAAE;AAChF,gBAAgB,iBAAiB,EAAE,wBAAwB,EAAE;AAC7D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA,sBAAsB,oBAAoB,EAAE;AAC5C;EACE,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,4DAA4D;EAC5D,sDAAsD;EACtD,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,kBAAkB,sDAAsD,EAAE;AAC1E;EACE,eAAe;EACf,2BAA2B;EAC3B,qDAAqD;EACrD,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;AAC1B;AACA,0BAA0B,2BAA2B,EAAE,oBAAoB,EAAE;AAC7E,kBAAkB,iBAAiB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE;;AAEnF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA,kBAAkB,0BAA0B,EAAE;;AAE9C,iCAAiC;AACjC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;AACA,kBAAkB,iBAAiB,EAAE,cAAc,EAAE,oBAAoB,EAAE,WAAW,EAAE;AACxF,mBAAmB,SAAS,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE;AACjG,kBAAkB,iBAAiB,EAAE,iBAAiB,EAAE;AACxD;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,uCAAuC;EACvC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA,0BAA0B,kBAAkB,EAAE;;AAE9C;EACE,oBAAoB,WAAW,EAAE;EACjC,cAAc,cAAc,EAAE,YAAY,EAAE;AAC9C","sourcesContent":["/* ── Bloque «Documentación de la empresa» del Dashboard ─────────────────────\r\n   Usa las variables de tema de la CMDB (--bg-surface, --border…) para que se\r\n   lea igual en los 12 temas y en las 5 pieles, incluidas las Lumina oscuras\r\n   donde --bg-card es translúcido. */\r\n\r\n.dbd {\r\n  background: var(--bg-surface, var(--bg-card));\r\n  border: 1px solid var(--border);\r\n  border-radius: 14px;\r\n  padding: 1rem 1.15rem;\r\n  margin-bottom: 1.25rem;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, .08);\r\n}\r\n\r\n/* ── Cabecera ── */\r\n.dbd-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n.dbd-head-copy { min-width: 220px; }\r\n.dbd-title {\r\n  margin: 0;\r\n  font-size: 1.02rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n.dbd-subtitle {\r\n  margin: .15rem 0 0;\r\n  font-size: .8rem;\r\n  color: var(--text-muted);\r\n}\r\n.dbd-head-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: .5rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.dbd-search {\r\n  min-width: 220px;\r\n  padding: .42rem .6rem;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-input, rgba(255, 255, 255, .06));\r\n  color: var(--text-primary);\r\n  font-size: .82rem;\r\n}\r\n.dbd-search::placeholder { color: var(--text-muted); }\r\n.dbd-search:focus { outline: none; border-color: var(--accent); }\r\n\r\n.dbd-btn {\r\n  padding: .42rem .75rem;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-input, rgba(255, 255, 255, .06));\r\n  color: var(--text-secondary);\r\n  font-size: .8rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n.dbd-btn:hover { border-color: var(--accent); color: var(--accent); }\r\n.dbd-btn.is-primary {\r\n  background: var(--accent);\r\n  border-color: var(--accent);\r\n  color: #fff;\r\n}\r\n.dbd-btn.is-primary:hover { filter: brightness(1.1); color: #fff; }\r\n.dbd-btn:disabled { opacity: .6; cursor: not-allowed; }\r\n\r\n/* ── Formulario de nota rápida ── */\r\n.dbd-form {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: .5rem;\r\n  margin-top: .85rem;\r\n  padding: .8rem;\r\n  border-radius: 10px;\r\n  border: 1px dashed var(--border);\r\n  background: rgba(var(--accent-rgb, 99, 102, 241), .06);\r\n}\r\n.dbd-input {\r\n  flex: 1 1 240px;\r\n  padding: .45rem .65rem;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-input, rgba(255, 255, 255, .06));\r\n  color: var(--text-primary);\r\n  font-size: .84rem;\r\n}\r\n.dbd-input::placeholder { color: var(--text-muted); }\r\n.dbd-input:focus { outline: none; border-color: var(--accent); }\r\n.dbd-form-actions { display: flex; gap: .5rem; align-items: center; }\r\n.dbd-form-error {\r\n  flex: 1 1 100%;\r\n  font-size: .78rem;\r\n  color: #dc2626;\r\n}\r\n\r\n/* ── Listado ── */\r\n.dbd-list {\r\n  list-style: none;\r\n  margin: .9rem 0 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.dbd-row {\r\n  display: flex;\r\n  gap: .7rem;\r\n  padding: .65rem .25rem;\r\n  border-top: 1px solid var(--border);\r\n}\r\n.dbd-row:first-child { border-top: none; }\r\n.dbd-row-icon { font-size: 1.05rem; line-height: 1.5; }\r\n.dbd-row-main { flex: 1; min-width: 0; }\r\n\r\n.dbd-row-titleline {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: .5rem;\r\n  flex-wrap: wrap;\r\n}\r\n.dbd-row-title {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  font-size: .9rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n  text-align: left;\r\n}\r\n.dbd-row-title:hover { color: var(--accent); text-decoration: underline; }\r\n.dbd-status {\r\n  font-size: .64rem;\r\n  font-weight: 700;\r\n  padding: .1rem .4rem;\r\n  border-radius: 999px;\r\n  text-transform: uppercase;\r\n  letter-spacing: .03em;\r\n}\r\n.dbd-status.is-draft     { background: rgba(234, 179, 8, .18);  color: #ca8a04; }\r\n.dbd-status.is-published { background: rgba(22, 163, 74, .18);  color: #16a34a; }\r\n.dbd-row-date { font-size: .72rem; color: var(--text-muted); }\r\n.dbd-row-open {\r\n  margin-left: auto;\r\n  background: none;\r\n  border: none;\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n  font-size: .9rem;\r\n  line-height: 1;\r\n  padding: 0 .2rem;\r\n}\r\n.dbd-row-open:hover { color: var(--accent); }\r\n.dbd-row-desc {\r\n  margin: .2rem 0 0;\r\n  font-size: .78rem;\r\n  color: var(--text-secondary);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 1;\r\n  -webkit-box-orient: vertical;\r\n}\r\n\r\n/* ── Chips de elementos vinculados ── */\r\n.dbd-links {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: .35rem;\r\n  margin-top: .45rem;\r\n}\r\n.dbd-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: .3rem;\r\n  max-width: 260px;\r\n  padding: .18rem .5rem;\r\n  border-radius: 999px;\r\n  border: 1px solid rgba(var(--accent-rgb, 99, 102, 241), .35);\r\n  background: rgba(var(--accent-rgb, 99, 102, 241), .12);\r\n  color: var(--accent);\r\n  font-size: .72rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.dbd-chip:hover { background: rgba(var(--accent-rgb, 99, 102, 241), .22); }\r\n.dbd-chip.is-static {\r\n  cursor: default;\r\n  border-color: var(--border);\r\n  background: var(--bg-input, rgba(255, 255, 255, .06));\r\n  color: var(--text-muted);\r\n}\r\n.dbd-chip.is-more {\r\n  border-style: dashed;\r\n  border-color: var(--border);\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n}\r\n.dbd-chip.is-more:hover { border-color: var(--accent); color: var(--accent); }\r\n.dbd-links-none { font-size: .74rem; color: var(--text-muted); font-style: italic; }\r\n\r\n.dbd-more {\r\n  margin-top: .6rem;\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  color: var(--accent);\r\n  font-size: .8rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n.dbd-more:hover { text-decoration: underline; }\r\n\r\n/* ── Estados vacíos / error ── */\r\n.dbd-empty {\r\n  margin-top: .85rem;\r\n  padding: 1rem;\r\n  border-radius: 10px;\r\n  border: 1px dashed var(--border);\r\n  text-align: center;\r\n  color: var(--text-muted);\r\n  font-size: .82rem;\r\n}\r\n.dbd-empty-icon { font-size: 1.6rem; display: block; margin-bottom: .3rem; opacity: .6; }\r\n.dbd-empty-title { margin: 0; font-weight: 700; color: var(--text-secondary); font-size: .88rem; }\r\n.dbd-empty-copy { margin: .2rem 0 0; font-size: .78rem; }\r\n.dbd-error {\r\n  margin-top: .85rem;\r\n  padding: .6rem .8rem;\r\n  border-radius: 10px;\r\n  background: rgba(220, 38, 38, .12);\r\n  border: 1px solid rgba(220, 38, 38, .4);\r\n  color: #dc2626;\r\n  font-size: .8rem;\r\n}\r\n\r\n.dbd.is-full {\r\n  margin-bottom: 0;\r\n  padding: 1.15rem 1.3rem;\r\n}\r\n.dbd.is-full .dbd-title { font-size: 1.15rem; }\r\n\r\n@media (max-width: 720px) {\r\n  .dbd-head-actions { width: 100%; }\r\n  .dbd-search { flex: 1 1 100%; min-width: 0; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
